// extracted by mini-css-extract-plugin
export default {"subheader":"subheader_subheader__IQs3S","heading":"subheader_heading__MR0hu"};